module.exports = __webpack_public_path__ + "static/media/4.1b165220.jpg";